import React from "react";
import ReactDOM from "react-dom/client";
import "./api/apiClient"; // Retry on ERR_CONNECTION_REFUSED (remote backend)
import "./index.css";
import App from "./App";

// Add error handler for unhandled errors
window.addEventListener("error", (event) => {
  console.error("Unhandled error:", event.error);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Unhandled promise rejection:", event.reason);
});

// Check if root element exists
const rootElement = document.getElementById("root");
if (!rootElement) {
  console.error("Root element not found!");
  document.body.innerHTML = '<div style="padding: 20px; color: red;">Error: Root element not found!</div>';
} else {
  try {
    const root = ReactDOM.createRoot(rootElement);
    // StrictMode disabled: causes double-mount in dev which triggers carousel flicker + image reload
    root.render(<App />);
  } catch (error) {
    console.error("Failed to render app:", error);
    rootElement.innerHTML = `
      <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; min-height: 100vh; padding: 20px; background-color: #2c3e50; color: #fff; font-family: Arial, sans-serif;">
        <h1 style="font-size: 2rem; margin-bottom: 20px;">⚠️ Failed to Load Application</h1>
        <p style="margin-bottom: 20px; text-align: center;">${error.message}</p>
        <button onclick="window.location.reload()" style="padding: 10px 20px; font-size: 1rem; background-color: #6F4E37; color: #fff; border: none; border-radius: 5px; cursor: pointer;">
          Refresh Page
        </button>
      </div>
    `;
  }
}
